import { render, staticRenderFns } from "./AdditionalDataUploader.vue?vue&type=template&id=28172278&scoped=true&"
import script from "./AdditionalDataUploader.vue?vue&type=script&lang=js&"
export * from "./AdditionalDataUploader.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalDataUploader.vue?vue&type=style&index=0&id=28172278&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28172278",
  null
  
)

export default component.exports